import type { Dispatch, PropsWithChildren, SetStateAction } from 'react';
import { createContext, useMemo, useState } from 'react';

export type SheetIds =
  | 'project-switcher'
  | 'uploads'
  | 'dev-tools'
  | 'notifications'
  | 'whats-new'
  | 'project-navigation'
  | 'secure-reviewer-notifications'
  | 'settings-navigation'
  | 'workspaces-navigation'
  | null; // closes an existing sheet

/**
 * App sheet controller context. Used bu `useAppSheetButton`
 * to control the sheet visibility and contents.
 */
export const AppSheetContext = createContext<{
  id: SheetIds;
  setId?: Dispatch<SetStateAction<SheetIds>>;
}>({
  id: null,
  setId: undefined,
});

export const AppSheetContextProvider = (props: PropsWithChildren) => {
  const [id, setId] = useState<SheetIds>(null);

  const context = useMemo(
    () => ({
      id,
      setId,
    }),
    [id]
  );

  return (
    <AppSheetContext.Provider value={context}>
      {props.children}
    </AppSheetContext.Provider>
  );
};
